export default "__VITE_ASSET__C8n71_Xb__"